import iggiLogo from '../img/logo/iggi.png';
import osteriaLogo from '../img/logo/osteria_2.svg';

import { Link } from 'react-router-dom';
import HomepageBlock from './HomepageBlock';
import Footer from './Footer';
import Topbar from './Topbar';
import { useGetTableData } from './TableStatus';
import Seo from './Seo';
import AboutUs from './AboutUs';
import Cocktails from './Cocktails';
import Faq from './Faq';
import United from './United';
import Bus from './bus';
import Garden from './Garden';

import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getOrganizationSchema, getPageSeo, getWebPageSchema, getWebsiteSchema } from '../seo';

const Homepage = ({ sectionId = null, seoPage = 'home' }) => {
    const tableData = useGetTableData();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const meta = getPageSeo(seoPage, t);
    const schema = seoPage === 'home'
        ? [getOrganizationSchema(i18n.language), getWebsiteSchema(i18n.language)]
        : [getWebPageSchema(meta, i18n.language)];

    useEffect(() => {
        const targetSectionId = sectionId || location.hash.slice(1);
        if (!targetSectionId) return;

        const section = document.getElementById(targetSectionId);
        if (section) {
            setTimeout(() => {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 0);
        }
    }, [location.hash, sectionId]);

    const getSnippetProps = (id) => (
        sectionId && sectionId !== id ? { 'data-nosnippet': '' } : {}
    );

    const getHeadingLevel = (id) => (
        sectionId === id ? 'h1' : 'h2'
    );

    return(
        <>
            <Seo {...meta} schema={schema} />
            <Topbar />
            <main>
                <div className="blocks" id="home" {...getSnippetProps('home')}>
                    {!sectionId && <h1 className="srOnly">IGGI Bārs</h1>}
                    <Link
                        to="/iggirezekne"
                        className="block first-block"
                        >
                        <HomepageBlock tableData={tableData} logo={iggiLogo} logoAlt="IGGI Bārs Rēzekne" city="Rēzekne" phone="22 107 107" address="Atbrīvošanas aleja 95C" rest="iggirezekne"/>
                    </Link>
                    <Link
                        to="/osteria"
                        className="block second-block"
                        >
                        <HomepageBlock
                            tableData={tableData}
                            logo={osteriaLogo}
                            logoAlt="Osteria by IGGI"
                            city="Rēzekne"
                            address="Atbrīvošanas aleja 142"
                            rest="osteria"
                            phone="26 104 104"
                            showStatus={true}
                        />
                    </Link>
                    <Link
                        to="/iggidaugavpils"
                        className="block third-block"
                        >
                        <HomepageBlock tableData={tableData} logo={iggiLogo} logoAlt="IGGI Bārs Daugavpils" city="Daugavpils" phone="28 008 600" address="Rīgas iela 22" rest="iggidaugavpils" />
                    </Link>
                </div>
                <section id="parmums" {...getSnippetProps('parmums')}>
                    <AboutUs headingLevel={getHeadingLevel('parmums')} />
                </section>
                <section id="kokteili" {...getSnippetProps('kokteili')}>
                    <Cocktails headingLevel={getHeadingLevel('kokteili')} />
                </section>
                <section id="izbraukumi" {...getSnippetProps('izbraukumi')}>
                    <Bus headingLevel={getHeadingLevel('izbraukumi')} />
                </section>
                <section id="tirgus" {...getSnippetProps('tirgus')}>
                    <Garden headingLevel={getHeadingLevel('tirgus')} />
                </section>
                <section id="united" {...getSnippetProps('united')}>
                    <United headingLevel={getHeadingLevel('united')} />
                </section>
                <section id="buj" {...getSnippetProps('buj')}>
                    <Faq headingLevel={getHeadingLevel('buj')} />
                </section>
            </main>
            <Footer />
        </>
    )
}

export default Homepage;
